<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()">
        <i class="material-icons">close</i>
    </div>
    <div class="content" >
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/are_you_sure.png" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3"> {{" Contact Administrator " |translate}}</h5>
        <div class="item-small mt-3 text-center">To purchase the course, please contact administrator via  <a href="mailto:info@univate.ie">info@univate.ie</a>.</div>
    </div>
    
    <div class="btn-container d-flex mt-4">
        <a href="mailto:info@univate.ie" >
          <button type="button"
            class="btn btn-primary  d-flex align-items-center justify-content-center">
            Contact
          </button>
        </a>
      </div>
      
</div>
<app-loading-spinner></app-loading-spinner>